import { render, staticRenderFns } from "./layer-edit-publish.vue?vue&type=template&id=64e3775a&scoped=true&"
import script from "./layer-edit-publish.vue?vue&type=script&lang=js&"
export * from "./layer-edit-publish.vue?vue&type=script&lang=js&"
import style0 from "./layer-edit-publish.vue?vue&type=style&index=0&id=64e3775a&lang=scss&scoped=true&"
import style1 from "./layer-edit-publish.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e3775a",
  null
  
)

export default component.exports